function Clientes(params) {
    return (
        <>
            Clientes
        </>
    )
}

export default Clientes